// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3330": "1852a85dfba9","8795": "631c6af3ebb8","8990": "7d69c8cdd354",}[chunkId] + ".css"
}